import React, { useEffect, useRef, useState } from "react";

/**
 * Base vs quote currency picker for the Spot Amount field (Market, Stop Market, Stop Limit).
 * Matches custom select pattern: light trigger, panel with checkmark on selected row.
 */
export default function TradeAmountDenomSelect({ value, onChange, baseSymbol, quoteSymbol }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const label = value === "QUOTE" ? quoteSymbol : baseSymbol;
  const options = [
    { key: "BASE", sym: baseSymbol },
    { key: "QUOTE", sym: quoteSymbol },
  ];

  return (
    <div className="trade_amt_denom_select" ref={rootRef}>
      <button
        type="button"
        className={`trade_amt_denom_select__trigger${open ? " is-open" : ""}`}
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="trade_amt_denom_select__label">{label}</span>
        <i
          className={`trade_amt_denom_select__chev ri-arrow-${open ? "up" : "down"}-s-fill`}
          aria-hidden="true"
        />
      </button>
      {open ? (
        <ul className="trade_amt_denom_select__panel" role="listbox">
          {options.map((o) => (
            <li key={o.key} role="presentation">
              <button
                type="button"
                className="trade_amt_denom_select__option"
                role="option"
                aria-selected={value === o.key}
                onClick={() => {
                  onChange(o.key);
                  setOpen(false);
                }}
              >
                <span>{o.sym}</span>
                {value === o.key ? (
                  <span className="trade_amt_denom_select__check" aria-hidden="true">
                    <i className="ri-check-line" aria-hidden="true" />
                  </span>
                ) : null}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
